//
import styled from 'styled-components';

const OneHrFilterWrapper = styled.div`
  display: flex;
  gap: 10px;
  background-color: ${(props) => props.theme.colors.WHITE};
  flex: 1;

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXM};
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXM};
  }
`;

export const OneHrFilterTextArea = styled.div`
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    max-width: 70%;
  }
`;

export const DefaultStoreMessage = styled.span`
  font-weight: 700;
`;

export const PickupLabel = styled.span`
  font-weight: 600;
`;

export default OneHrFilterWrapper;
